// extracted by mini-css-extract-plugin
export default {"pithy":"Objective_pithy__QWF9t","punny":"Objective_punny__G+HlC","passionate":"Objective_passionate__Pcg6V","Objective":"Objective_Objective__PU89D"};